import { Link } from 'react-router-dom';
import { contact, navLinks } from '../data/site';

const NewFooter = () => (
  <footer className="site-footer">
    <div className="container site-footer__grid">
      <div>
        <p className="site-footer__name">Sneh Communications</p>
        <p className="site-footer__text">
          Medical equipment, diagnostic kits, radiology equipment and blood bank products
          for hospitals and diagnostic centres across Northern India.
        </p>
      </div>
      <div>
        <h2 className="site-footer__heading">Quick links</h2>
        <ul className="site-footer__list">
          {navLinks.map((item) => (
            <li key={item.to}><Link to={item.to}>{item.label}</Link></li>
          ))}
          <li><Link to="/contact">Contact us</Link></li>
        </ul>
      </div>
      <div>
        <h2 className="site-footer__heading">Get in touch</h2>
        <ul className="site-footer__list">
          <li><a href={contact.phoneLink}>{contact.phone}</a></li>
          <li><a href={contact.emailLink}>{contact.email}</a></li>
          <li><a href={contact.mapLink} target="_blank" rel="noreferrer">{contact.address}</a></li>
        </ul>
      </div>
    </div>
    <div className="container site-footer__bottom">
      © {new Date().getFullYear()} Sneh Communications. All rights reserved.
    </div>
  </footer>
);

export default NewFooter;
